import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CwpNgFrameworkModule } from '@blk/cwp-ng-framework';
import { DAISY_PICTOGRAMS, dzDiversification, dzEconomicGrowth, dzEsg, dzIncome, DzPictogramsModule, dzProtection, dzSavings } from '@blk/daisy/core/pictograms';

import { ModelsExperienceFilterCardComponent } from './filter-card';
import { HighlightedFiltersComponent } from './highlighted-filters.component';

@NgModule({
	declarations: [HighlightedFiltersComponent, ModelsExperienceFilterCardComponent],
	imports: [CommonModule, CwpNgFrameworkModule, DzPictogramsModule],
	exports: [HighlightedFiltersComponent, ModelsExperienceFilterCardComponent],
	providers: [
		{
			provide: DAISY_PICTOGRAMS,
			useValue: [dzSavings, dzProtection, dzDiversification, dzEsg, dzIncome, dzEconomicGrowth],
			multi: true
		}
	]
})
export class HighlightedFiltersModule { }
